export default __webpack_public_path__ + "static/Construction-Dumpsters-067f26ffa259d9663a4822bbaf5ad0ab.jpg";